<template>
<div>
    <h1 class="display-heading">Covid-19 Vaccination Booking</h1>

    <div class="bs-stepper">
        <div class="bs-stepper-header" role="tablist">
            <div class="step" data-target="#user-details">
                <button
                    type="button"
                    class="step-trigger"
                    role="tab"
                    aria-controls="user-details"
                    id="user-details-trigger"
                >
                    <span class="bs-stepper-circle">1</span>
                    <span class="bs-stepper-label">User Details</span>
                </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#review">
                <button
                    type="button"
                    class="step-trigger"
                    role="tab"
                    aria-controls="review"
                    id="review-trigger"
                >
                    <span class="bs-stepper-circle">2</span>
                    <span class="bs-stepper-label"
                        >Review</span
                    >
                </button>
            </div>
        </div>
        <div class="bs-stepper-content">
            <!-- your steps content here -->
                <div
                    id="user-details"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="user-details-trigger"

                >
                    <p><b>Please enter your details.</b></p>
                    <div class="row">

                        <div class="form-group col-lg-6">
                            <label for="">Nationality</label>
                            <input type="text" placeholder="Eg. Malaysian" name="nationality" v-model="nationality"
                            data-vv-as="nationality" data-vv-validate-on="blur"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('nationality')
                            }">
                            <div v-show="validationErrors.has('nationality')"
                                class="invalid-feedback">
                                {{ validationErrors.first('nationality') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">MySejahtera ID</label>
                            <input type="text" placeholder="MySejahtera ID" name="mySejahteraId" v-model="mySejahteraId"
                            data-vv-as="MySejahtera ID" data-vv-validate-on="blur"
                            v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('mySejahteraId')
                            }">
                            <div v-show="validationErrors.has('mySejahteraId')"
                                class="invalid-feedback">
                                {{ validationErrors.first('mySejahteraId') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-6">
                            <label class="mb-0">Region</label>
                            <div class="mb-2"><small>Note: choose the nearest region, if your region is unavailable.</small></div>
                            <select name="region" data-vv-validate-on="blur" data-vv-as="region"
                                v-model="regionId" value="1" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('region')
                            }">
                                <option v-for="(region, index) in regions" :key="index"
                                    :value="region.id">
                                    {{region.name}}
                                </option>
                            </select>

                            <div v-show="validationErrors.has('region')" class="invalid-feedback">
                                {{ validationErrors.first('region') }}
                            </div>
                        </div>

                    </div>

                    <!-- Next Button -->
                    <button
                        @click="nextStep(1)"
                        class="btn btn-primary btn-primary-insv"
                    >
                        Next
                    </button>
                </div>

                <div
                    id="review"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="review-trigger"
                >
                    <p><b>Please review your details, to change your profile information, please proceed to profile tab.</b></p>
                    <div class="row">

                        <!-- Payment info -->
                        <table class="table table-bordered table-sm">
                            <colgroup>
                                <col width="250">
                                <col>
                            </colgroup>
                            <tr>
                                <th colspan="2" class="text-uppercase">Payment info</th>
                            </tr>
                            <tr>
                                <th>Vaccine</th> <!-- Hardcode for now -->
                                <td>Sinovac</td>
                            </tr>
                            <tr>
                                <th>Price</th> <!-- Hardcode for now -->
                                <td>RM 360</td>
                            </tr>
                        </table>

                        <div class="form-group col-lg-6">
                            <label for="">Name</label>
                            <input class="form-control" disabled type="text" v-model="name">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Phone</label>
                            <input class="form-control" disabled type="text" v-model="phone">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Email</label>
                            <input class="form-control" disabled type="text" v-model="email">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Identity Card Number</label>
                            <input class="form-control" disabled type="text" v-model="identityCardNumber">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Date of Birth</label>
                            <input class="form-control" disabled type="text" v-model="dob">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Gender</label>
                            <input class="form-control" disabled type="text" v-model="gender">
                        </div>

                        <div class="form-group col-lg-6">
                            <label for="">Nationality</label>
                            <input class="form-control" disabled type="text" v-model="nationality">
                        </div>

                        <div  class="form-group col-lg-6">
                            <label for="">MySejahtera ID</label>
                            <input class="form-control" disabled type="text" v-model="mySejahteraId">
                        </div>

                        <div class="form-group col-lg-6">
                            <label>Region</label>
                            <select disabled v-model="regionId" class="form-control">
                                <option v-for="(region, index) in regions" :key="index"
                                    :value="region.id">
                                    {{region.name}}
                                </option>
                            </select>

                            <div v-show="validationErrors.has('region')" class="invalid-feedback">
                                {{ validationErrors.first('region') }}
                            </div>
                        </div>

                    </div>

                    <p class="text-danger">You will be redirected to payment after you click "Book".</p>
                    <!-- Back Button -->
                    <button
                        @click="previousStep"
                        class="btn btn-secondary"
                    >
                        Previous
                    </button>

                    <!-- Next Button -->
                    <button
                        @click="showConfirmationBeforeSubmit"
                        class="btn btn-primary btn-primary-insv ml-2"
                    >
                        Book
                    </button>
                </div>
        </div>
    </div>

    <div style="display: none;">
        <form ref="insvPayment" method="post" :action="paymentSubmitPath">
            <input type="text" name="UseWallet" value="false" />
            <input type="text" name="PaymentWalletAmount"  value="0" />
            <input type="text" name="PaymentSummaryId"  v-model="paymentSummaryId" />
            <input type="text" name="PaymentRemarks" value="Vaccination" />
            <input name="Token" v-model="token" type="hidden">
        </form>
    </div>

    <popup-modal ref="popupBookingConfirmation" title="Important Notice" :hasCloseButton="true" sizeClass="modal-xl">
        <template slot="content">
            <p>
                Note : The following terms and conditions will be applied. You are advised to read and accept them before making your booking.
            </p>
            <ol>
                <li>
                    No refund nor replacement for any paid vaccination, if you failed to attend the given appointment.
                    <p class="mt-2">
                        Reason : Sinovac vaccine is sold in a vial packaging, whereby each vial is allocated for 2 persons’ vaccination about same time. Unused vaccine must be discarded once a vial is opened.
                    </p>
                </li>
                <li>
                    We will assign a vaccination’s appointment to a clinic locating nearest to your region. SMS will be sent out to your handphone number for confirming your actual location and time of vaccination, within a week after payment is made.
                    <p class="mt-2">
                        Reason : Depending on the current stocks of vaccines at respective clinics during your booking.
                    </p>
                </li>
            </ol>
        </template>

        <template slot="footer">
            <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="dismissAndContinueToPayment">
                Proceed to Make Payment
            </button>
            <button type="button" class="btn btn-secondary" @click="()=>{ $refs.popupBookingConfirmation.hide(); }">Discard</button>
        </template>
    </popup-modal>
</div>
</template>

<script>
import { convertDateToDDMMYYYY } from '@/utilities';
import { apiPath } from '@/config';
import Stepper from 'bs-stepper';
import Cookies from 'js-cookie';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'UserVaccinationBooking',
    'components': {
        popupModal
    },
    data () {
        return {
            'name': '',
            'phone': '',
            'email': '',
            'identityCardNumber': '',
            'dob': '',
            'gender': '',
            'nationality': '',
            'mySejahteraId': '',
            'vaccine': 1, // Hardcode vaccine for now
            'regionId': 1,
            'regions': [],
            'paymentSummaryId': null
        };
    },
    'computed': {
        paymentSubmitPath () {
            return `${apiPath}MakePayment/Pay`;
        },
        token () {
            return Cookies.get('t');
        }
    },
    'methods': {
        async nextStep (step) {
            if (step === 1) {
                var result = await this.$validator.validateAll();
                if (!result) {
                    return false;
                }
            }
            this.stepper.next();
        },
        previousStep () {
            this.stepper.previous();
        },
        showConfirmationBeforeSubmit () {
            this.$refs.popupBookingConfirmation.show();
        },
        dismissAndContinueToPayment () {
            this.$refs.popupBookingConfirmation.hide(() => {
                this.submit();
            });
        },
        submit () {
            this.axios.post('Vaccination/UserBooking', {
                'vi': this.vaccine,
                'r': this.regionId,
                'na': this.name,
                'msi': this.mySejahteraId
            }).then((response) => {
                this.paymentSummaryId = response.data.data.paymentSummaryId;
                this.$nextTick(() => {
                    this.$refs.insvPayment.submit();
                });
            });
        },
        getRegions () {
            this.axios.get('Region/GetAll').then((response) => {
                this.regions = response.data.data.regions.map((region) => {
                    return {
                        'id': region.i,
                        'name': region.n
                    };
                });
            });
        },
        getProfile () {
            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                let profileData = data.data;
                this.name = profileData.f;
                this.email = profileData.e;
                this.identityCardNumber = profileData.ic;
                this.dob = convertDateToDDMMYYYY(profileData.bd);
                this.gender = profileData.g === 1 ? 'Male' : 'Female';
                this.phone = profileData.p;
            });
        }
    },
    mounted () {
        this.getProfile();
        this.getRegions();
        // Setup Stepper
        this.stepper = new Stepper(document.querySelector('.bs-stepper'));
    }
};
</script>

<style>

</style>
